/**
 * Mapping des départements français vers les 8 zones horticoles.
 *
 * Zone 1 : Littoral méditerranéen (climat très doux)
 * Zone 2 : Arrière-pays méditerranéen et Corse
 * Zone 3 : Sud-Ouest atlantique
 * Zone 4 : Ouest atlantique
 * Zone 5 : Centre, Bassin parisien
 * Zone 6 : Nord et Nord-Est
 * Zone 7 : Est et zones d'altitude moyenne
 * Zone 8 : Montagne (altitude > 600m, zones froides)
 */

export const DEPARTMENT_TO_ZONE: Record<string, number> = {
  // Zone 1 — Méditerranée littorale
  "06": 1, // Alpes-Maritimes
  "13": 1, // Bouches-du-Rhône
  "83": 1, // Var
  "66": 1, // Pyrénées-Orientales

  // Zone 2 — Arrière-pays méditerranéen, Corse
  "11": 2, // Aude
  "30": 2, // Gard
  "34": 2, // Hérault
  "84": 2, // Vaucluse
  "2A": 2, // Corse-du-Sud
  "2B": 2, // Haute-Corse
  "04": 2, // Alpes-de-Haute-Provence
  "07": 2, // Ardèche (sud)
  "26": 2, // Drôme (sud)

  // Zone 3 — Sud-Ouest atlantique
  "33": 3, // Gironde
  "40": 3, // Landes
  "64": 3, // Pyrénées-Atlantiques
  "47": 3, // Lot-et-Garonne
  "32": 3, // Gers
  "31": 3, // Haute-Garonne
  "82": 3, // Tarn-et-Garonne
  "81": 3, // Tarn
  "09": 3, // Ariège
  "65": 3, // Hautes-Pyrénées
  "46": 3, // Lot
  "24": 3, // Dordogne
  "12": 3, // Aveyron
  "48": 3, // Lozère

  // Zone 4 — Ouest atlantique
  "17": 4, // Charente-Maritime
  "85": 4, // Vendée
  "44": 4, // Loire-Atlantique
  "56": 4, // Morbihan
  "29": 4, // Finistère
  "22": 4, // Côtes-d'Armor
  "35": 4, // Ille-et-Vilaine
  "50": 4, // Manche
  "14": 4, // Calvados
  "76": 4, // Seine-Maritime
  "16": 4, // Charente
  "79": 4, // Deux-Sèvres
  "86": 4, // Vienne
  "49": 4, // Maine-et-Loire
  "53": 4, // Mayenne
  "72": 4, // Sarthe

  // Zone 5 — Centre, Bassin parisien
  "75": 5, // Paris
  "77": 5, // Seine-et-Marne
  "78": 5, // Yvelines
  "91": 5, // Essonne
  "92": 5, // Hauts-de-Seine
  "93": 5, // Seine-Saint-Denis
  "94": 5, // Val-de-Marne
  "95": 5, // Val-d'Oise
  "28": 5, // Eure-et-Loir
  "45": 5, // Loiret
  "41": 5, // Loir-et-Cher
  "37": 5, // Indre-et-Loire
  "36": 5, // Indre
  "18": 5, // Cher
  "58": 5, // Nièvre
  "89": 5, // Yonne
  "10": 5, // Aube
  "27": 5, // Eure
  "61": 5, // Orne
  "87": 5, // Haute-Vienne
  "23": 5, // Creuse
  "03": 5, // Allier
  "63": 5, // Puy-de-Dôme
  "43": 5, // Haute-Loire
  "15": 5, // Cantal
  "19": 5, // Corrèze
  "71": 5, // Saône-et-Loire
  "42": 5, // Loire
  "69": 5, // Rhône

  // Zone 6 — Nord et Nord-Est
  "59": 6, // Nord
  "62": 6, // Pas-de-Calais
  "80": 6, // Somme
  "60": 6, // Oise
  "02": 6, // Aisne
  "51": 6, // Marne
  "08": 6, // Ardennes

  // Zone 7 — Est continental
  "57": 7, // Moselle
  "54": 7, // Meurthe-et-Moselle
  "55": 7, // Meuse
  "88": 7, // Vosges
  "52": 7, // Haute-Marne
  "21": 7, // Côte-d'Or
  "70": 7, // Haute-Saône
  "25": 7, // Doubs
  "39": 7, // Jura
  "01": 7, // Ain
  "67": 7, // Bas-Rhin
  "68": 7, // Haut-Rhin
  "90": 7, // Territoire de Belfort

  // Zone 8 — Montagne
  "38": 8, // Isère (montagne)
  "73": 8, // Savoie
  "74": 8, // Haute-Savoie
  "05": 8, // Hautes-Alpes
};

export const ZONE_LABELS: Record<number, string> = {
  1: "Méditerranée littorale",
  2: "Arrière-pays méditerranéen",
  3: "Sud-Ouest atlantique",
  4: "Ouest atlantique",
  5: "Centre & Bassin parisien",
  6: "Nord & Nord-Est",
  7: "Est continental",
  8: "Montagne",
};

/**
 * Returns the climate zone for a department code.
 * Defaults to zone 5 (Centre) if not found.
 */
export function getClimateZone(department: string): number {
  return DEPARTMENT_TO_ZONE[department] ?? 5;
}

/**
 * Returns the zone label for display.
 */
export function getClimateZoneLabel(zone: number): string {
  return ZONE_LABELS[zone] ?? "Zone inconnue";
}
